import { makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles({
  flexGrowNoShrink: {
    flexGrow: 1,
    flexShrink: 1,
    overflow: "hidden"
  }
});

export default function Content(props) {
  const { content } = props;
  const classes = useStyles();
  return <div className={classes.flexGrowNoShrink}>{content}</div>;
}
